/**
 * The way back from a page that lives outside the personal area (no sidebar, no fund) to the
 * screen the user left for it - today only the open-fund form (HAT-1370).
 *
 * The path travels as router state, which only an in-app navigation can set. A visitor who
 * arrives from the landing site or from a link in an email never carries it, so those pages
 * keep sending them where they always did.
 */
export interface ReturnToState {
  returnTo: string;
}

export const returnToState = (pathname: string, search: string): ReturnToState => ({
  returnTo: `${pathname}${search}`,
});

/** The path to go back to, or undefined when the page was not opened from inside the app. */
export const readReturnTo = (state: unknown): string | undefined => {
  const value = (state as Partial<ReturnToState> | null | undefined)?.returnTo;
  // An in-app path only: '//host' is read by the browser as another site.
  return typeof value === 'string' && value.startsWith('/') && !value.startsWith('//') ? value : undefined;
};
